import React from 'react';
import { useHits } from 'react-instantsearch';

const ArticleCards = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { hits, sendEvent } = useHits(props);

    if (window.filtersInit) {
        document.getElementById('listing').scrollIntoView({behavior: 'instant'});
    } else {
        setTimeout(function() {
            window.filtersInit = true;
        }, 1000)
    }

    if (hits.length) {
        return (
            <div className="grid grid-cols-12 gap-5">
                {hits.map((hit) => (
                    <div key={hit.objectID} data-type={props.type} className="flex col-span-full sm:col-span-6 xl:col-span-4">
                        <article className="bg-white drop-shadow-lg flex flex-col w-full">

                            <a href={ hit.gated ? hit.gated : props.baseUrl + hit.url } className="block relative overflow-hidden group">
                                <img srcSet={ hit.image } alt={ hit.alt } loading="lazy" width="384" height="216" className="aspect-[16/9] h-full w-full object-cover object-center transition ease-linear duration-300 group-hover:scale-105" />
                                { hit.gated &&
                                <div className="absolute top-0 right-0 pointer-events-none p-4">
                                    <div className="bg-white/80 rounded uppercase p-2 text-sm tracking-wide">
                                        <svg className="opacity-70" width="21" height="20" viewBox="0 0 27 26"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill="#000"
                                                d="M13.5 21.53l-8.371 4.401 1.598-9.321-6.772-6.602 9.36-1.36L13.5.167l4.186 8.48 9.36 1.36-6.773 6.603 1.598 9.321z"
                                                fillRule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                                }
                            </a>

                            <div className="flex flex-col justify-between flex-1 gap-5 p-5">
                                <div>
                                    <div>
                                        <a href={hit.gated ? hit.gated : props.baseUrl + hit.url}
                                            className="text-lg leading-snug font-bold decoration-transparent underline !line-clamp-3 transition ease-linear duration-300 hover:decoration-black">
                                            <h5>{hit.title}</h5>
                                        </a>
                                    </div>
                                    <p className="leading-relaxed mt-2 text-sm text-black/70 !line-clamp-3">{ hit.excerpt }</p>
                                </div>
                                <div className="inline-flex items-center">
                                    <a href={ props.baseUrl + hit.data.author.url } className="w-10 h-10 rounded-full shrink-0 overflow-hidden">
                                        <img srcSet={ hit.data.author.image } loading="lazy" className="h-full w-full" width="40" height="40" alt={`Photo of ${ hit.author }`} />
                                    </a>
                                    <div className="flex-grow flex flex-col pl-4">
                                        <a href={ props.baseUrl + hit.data.author.url } className="text-sm font-bold leading-snug decoration-transparent underline transition ease-linear duration-300 hover:decoration-black">{ hit.author }</a>
                                        <span className="text-grey-400 text-xs leading-snug mt-1">
                                            <time dateTime={ hit.data.atom }>{ hit.data.postDate }</time>
                                            <span className="block sm:inline"><span className="hidden sm:inline"> - </span>{ props.readtime?.replace('{time}', hit.readtime)}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </article>
                    </div>
                ))}
            </div>
        );
    } else {
        setTimeout(function() {
            document.getElementById('no-results')?.classList.remove('hidden');
        }, 500)

        return (
            <div id="no-results" className="border-2 border-grey-200 rounded p-6 sm:p-8 text-center max-w-screen-md mx-auto w-full hidden">
                <p className="font-bold text-green text-xl">{props.noresultsHeading}</p>
                <p className="text-sm md:text-base mt-2">{props.noresultsText}</p>
            </div>
        );
    }

}

export { ArticleCards }
